const clock = document.querySelector('.js-clock');
if(!clock || !clock.dataset.tz) return;

const timeZone = clock.dataset.tz;

const timePfx = clock.querySelector('.js-time-pfx');
const timeHour = clock.querySelector('.js-time-hour');
const timeHourSep = clock.querySelector('.js-time-hour-sep');
const timeMin = clock.querySelector('.js-time-min');
const timeMinSep = clock.querySelector('.js-time-min-sep');
const timeSec = clock.querySelector('.js-time-sec');
const timeSfx = clock.querySelector('.js-time-sfx');

const date = clock.querySelector('.js-date');

let lastDate = '';
let lastTime = '';

function updateClock() {
    const now = new Date;
    const nowd = now.toLocaleDateString(navigator.language, { timeZone, weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' });
    const nowt = now.toLocaleTimeString(navigator.language, { timeZone });

    if(lastDate !== nowd) {
        lastDate = nowd;
        date.textContent = nowd;
    }

    if(lastTime !== nowt) {
        lastTime = nowt;
        const parts = /^(.*?)([0-9]{1,2})(.*?)([0-9]{1,2})(.*?)([0-9]{1,2})(.*?)$/s.exec(nowt);
        timePfx.textContent = parts[1].trim();
        timeHour.textContent = parts[2].trim();
        timeHourSep.textContent = parts[3].trim();
        timeMin.textContent = parts[4].trim();
        timeMinSep.textContent = parts[5].trim();
        timeSec.textContent = parts[6].trim();
        timeSfx.textContent = parts[7].trim();
    }
}

updateClock();
setInterval(() => void updateClock(), 100);
